/* Luméa Nord – theme scripts */
(function () {
  'use strict';

  const formatMoney = (cents) => {
    const format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} kr';
    const value = (cents / 100);
    const fix = (n, d, thousands, decimal) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fix(value, 2, ',', '.');
        case 'amount_no_decimals': return fix(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(value, 0, '.', ',');
        case 'amount_with_space_separator': return fix(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fix(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fix(value, 2, "'", '.');
        default: return fix(value, 2, '.', ',');
      }
    });
  };

  /* Header shadow on scroll ------------------------------------------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu ---------------------------------------------------------- */
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuBtn = document.querySelector('[data-menu-open]');
  if (mobileMenu && menuBtn) {
    const setMenu = (open) => {
      mobileMenu.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
    };
    menuBtn.addEventListener('click', () => setMenu(true));
    mobileMenu.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', () => setMenu(false)));
  }

  /* Gallery -------------------------------------------------------------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('[data-slides]');
      if (!this.slides) return;
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.gallery__dots span'));
      this.count = this.slides.children.length;
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.thumb))));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index() - 1));
      if (next) next.addEventListener('click', () => this.go(this.index() + 1));
      let t;
      this.slides.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => this.mark(this.index()), 60);
      }, { passive: true });
    }
    index() { return Math.round(this.slides.scrollLeft / this.slides.clientWidth); }
    go(i) {
      const n = (i + this.count) % this.count;
      this.slides.scrollTo({ left: n * this.slides.clientWidth, behavior: 'smooth' });
      this.mark(n);
    }
    mark(n) {
      this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === n));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === n));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  /* Product info: bundles, variants, add to cart ------------------------ */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      this.qtyInput = this.querySelector('[data-quantity]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.addBtn = this.querySelector('[data-add-button]');
      this.errorEl = this.querySelector('[data-form-error]');
      const json = this.querySelector('[data-product-json]');
      this.data = json ? JSON.parse(json.textContent) : { variants: [] };

      this.querySelectorAll('[data-bundles] input').forEach((r) => {
        r.addEventListener('change', () => this.setQty(Number(r.dataset.qty)));
        if (r.checked) this.setQty(Number(r.dataset.qty));
      });

      const select = this.querySelector('[data-variant-select]');
      if (select) select.addEventListener('change', () => this.setVariant(Number(select.value)));

      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });

      // Sticky add-to-cart
      const sticky = document.querySelector(`[data-sticky-atc="${this.dataset.section}"]`);
      if (sticky && this.addBtn) {
        const io = new IntersectionObserver(([entry]) => {
          const below = entry.boundingClientRect.top < 0;
          const show = !entry.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
        });
        io.observe(this.addBtn);
        const btn = sticky.querySelector('[data-sticky-add]');
        if (btn) btn.addEventListener('click', () => this.add(btn));
      }
    }

    currentVariant() {
      const id = Number(this.idInput && this.idInput.value);
      return this.data.variants.find((v) => v.id === id) || this.data.variants[0];
    }

    setQty(q) {
      if (this.qtyInput) this.qtyInput.value = q;
    }

    setVariant(id) {
      if (this.idInput) this.idInput.value = id;
      const v = this.currentVariant();
      if (!v) return;
      this.querySelectorAll('[data-price] .price__current').forEach((el) => { el.textContent = formatMoney(v.price); });
      this.querySelectorAll('[data-bundles] .bundle').forEach((label) => {
        const q = Number(label.querySelector('input').dataset.qty);
        const p = label.querySelector('[data-bundle-price]');
        const c = label.querySelector('[data-bundle-compare]');
        if (p) p.textContent = formatMoney(v.price * q);
        if (c) c.textContent = formatMoney(Math.max(v.compare, v.price) * q);
      });
      if (this.addBtn) {
        this.addBtn.disabled = !v.available;
        const label = this.addBtn.querySelector('[data-add-label]');
        if (label) {
          if (!this.defaultLabel) this.defaultLabel = label.textContent;
          label.textContent = v.available ? this.defaultLabel : 'Slutsåld';
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    }

    async add(trigger) {
      const btn = this.addBtn;
      if (!btn || btn.disabled) return;
      btn.classList.add('is-loading');
      if (trigger) trigger.disabled = true;
      if (this.errorEl) this.errorEl.hidden = true;
      try {
        const res = await fetch(`${window.theme.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.idInput.value), quantity: Number(this.qtyInput.value || 1) }],
            sections: 'cart-drawer',
            sections_url: window.location.pathname
          })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Något gick fel');
        if (data.sections && data.sections['cart-drawer']) CartDrawer.render(data.sections['cart-drawer']);
        else await CartDrawer.refresh();
        CartDrawer.open();
      } catch (err) {
        if (this.errorEl) { this.errorEl.textContent = err.message; this.errorEl.hidden = false; }
      } finally {
        btn.classList.remove('is-loading');
        if (trigger) trigger.disabled = false;
      }
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  /* Scroll-to-buy buttons ------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-scroll-to-buy]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const target = (href.startsWith('#') && document.querySelector(href)) || document.querySelector('product-info');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* Cart drawer ---------------------------------------------------------- */
  const CartDrawer = {
    el() { return document.querySelector('[data-cart-drawer]'); },
    open() {
      const el = this.el();
      if (!el) { window.location.href = window.theme.routes.cart_url; return; }
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      const close = el.querySelector('.drawer__close');
      if (close) close.focus();
    },
    close() {
      const el = this.el();
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    },
    render(html) {
      const el = this.el();
      if (!el) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      if (fresh) el.innerHTML = fresh.innerHTML;
      const count = fresh ? fresh.querySelectorAll('.cart-item').length : 0;
      this.updateCount();
    },
    async refresh() {
      const res = await fetch(`${window.theme.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      this.render(data['cart-drawer']);
    },
    async updateCount() {
      try {
        const cart = await (await fetch(`${window.theme.routes.cart_url}.js`)).json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.dataset.cartCount = cart.item_count;
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      } catch (e) { /* ignore */ }
    },
    async change(line, quantity) {
      const el = this.el();
      el.classList.add('is-loading');
      try {
        const res = await fetch(`${window.theme.routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: 'cart-drawer' })
        });
        const data = await res.json();
        if (data.sections && data.sections['cart-drawer']) this.render(data.sections['cart-drawer']);
        else await this.refresh();
      } finally {
        el.classList.remove('is-loading');
      }
    }
  };
  window.CartDrawer = CartDrawer;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) {
      if (CartDrawer.el()) { e.preventDefault(); CartDrawer.open(); }
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      const a = e.target.closest('a[data-cart-close]');
      if (!a || a.getAttribute('href') === window.location.pathname) e.preventDefault();
      CartDrawer.close();
      return;
    }
    const item = e.target.closest('[data-cart-drawer] .cart-item');
    if (!item) return;
    const line = Number(item.dataset.line);
    const input = item.querySelector('[data-qty-input]');
    const change = e.target.closest('[data-qty-change]');
    if (change) CartDrawer.change(line, Math.max(0, Number(input.value) + Number(change.dataset.qtyChange)));
    if (e.target.closest('[data-remove]')) CartDrawer.change(line, 0);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-drawer] [data-qty-input]');
    if (!input) return;
    const item = input.closest('.cart-item');
    CartDrawer.change(Number(item.dataset.line), Math.max(0, Number(input.value)));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    CartDrawer.close();
    const m = document.querySelector('[data-mobile-menu].is-open');
    if (m) m.querySelector('[data-menu-close]').click();
  });

  /* Carousel ------------------------------------------------------------- */
  class CarouselSlider extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      if (!track) return;
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 20 : track.clientWidth);
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }
  if (!customElements.get('carousel-slider')) customElements.define('carousel-slider', CarouselSlider);

  /* Count-up numbers ----------------------------------------------------- */
  const counters = document.querySelectorAll('[data-count-to]');
  if (counters.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        const end = Number(entry.target.dataset.countTo);
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - start) / 1200);
          entry.target.textContent = `${Math.round(end * (1 - Math.pow(1 - p, 3)))}%`;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    counters.forEach((c) => io.observe(c));
  }
})();
